/**
 * Длительности движения — из скина, а не из компонента.
 *
 * CSS-переходы читают токены сами, а анимации на JS (`BaseReveal`,
 * появление на сводке) — нет: им нужно число. Брать его отсюда, а не писать
 * рядом с кодом, иначе Парчмент и Залив разъедутся ровно в тех местах, где
 * движением занимается скрипт.
 */

/** Пока стили не применились (SSR, первый кадр) — значение по умолчанию */
export function cssMs(name: string, fallback: number): number {
  if (typeof window === 'undefined') return fallback

  const raw = getComputedStyle(document.documentElement).getPropertyValue(name).trim()
  if (!raw) return fallback

  const value = Number.parseFloat(raw)
  if (Number.isNaN(value)) return fallback

  return raw.endsWith('ms') ? value : value * 1000
}

export function prefersReducedMotion(): boolean {
  return (
    typeof window !== 'undefined' &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches
  )
}
